import React from 'react';
import { Button, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles({
  root: { display: 'flex', alignItems: 'flex-end', gap: 14, marginBottom: 16 },
  text: { flex: 1, minWidth: 0 },
  counter: { fontSize: 11, letterSpacing: '.07em', textTransform: 'uppercase', color: '#8a93a0' },
  title: { fontSize: 22, fontWeight: 700, color: '#111827', marginTop: 3 },
  meta: { fontSize: 13, color: '#6b7280', marginTop: 3 },
  nav: { display: 'flex', gap: 8, flexShrink: 0 },
});

interface IProps {
  index: number;
  total: number;
  title: string;
  meta: string;
  onPrev(): void;
  onNext(): void;
}

const RatingPaneHeader = ({ index, total, title, meta, onPrev, onNext }: IProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.text}>
        <Typography className={classes.counter}>
          Партнер {index + 1} из {total}
        </Typography>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.meta}>{meta}</Typography>
      </div>
      <div className={classes.nav}>
        <Button variant="outlined" size="small" disabled={index === 0} onClick={onPrev}>
          ← Назад
        </Button>
        <Button variant="outlined" size="small" disabled={index >= total - 1} onClick={onNext}>
          Далее →
        </Button>
      </div>
    </div>
  );
};

export default RatingPaneHeader;
